import { render, staticRenderFns } from "./ImportStep.vue?vue&type=template&id=5f3b5d50&scoped=true&"
import script from "./ImportStep.vue?vue&type=script&lang=js&"
export * from "./ImportStep.vue?vue&type=script&lang=js&"
import style0 from "./ImportStep.vue?vue&type=style&index=0&id=5f3b5d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3b5d50",
  null
  
)

export default component.exports